'use client';

import { ReactNode, HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface PageProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  /**
   * 스크롤 컨테이너 모드.
   * - false (기본): 단순 패딩 래퍼. 스크롤은 부모(main-scroll-container)가 담당
   * - true: 페이지 자체가 고정 높이 + 내부 flex-col. sticky 탭/필터 있는 페이지용
   */
  scrollable?: boolean;
  /** scrollable 시 overflow-hidden 추가 (자식이 스크롤 직접 제어) */
  fixedHeight?: boolean;
  children: ReactNode;
}

/**
 * 페이지 컨테이너 atom.
 *
 * 기본 사용:
 * ```tsx
 * <Page>{content}</Page>
 * ```
 *
 * 탭/필터가 상단에 고정되고 본문 영역만 스크롤되는 페이지:
 * ```tsx
 * <Page scrollable>
 *   <Tabs />
 *   <div className="flex-1 overflow-y-auto">{list}</div>
 * </Page>
 * ```
 */
export default function Page({
  scrollable,
  fixedHeight,
  className,
  children,
  ...rest
}: PageProps) {
  return (
    <div
      {...rest}
      className={cn(
        'w-full px-8 py-8 sm:px-4 sm:py-4',
        scrollable && 'flex h-full flex-col',
        fixedHeight && 'overflow-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
}
